import React from 'react';
import { Segmented } from 'antd';
import ClassicIndexFundsTab from './IndexFundsTab';
import IndexFundsTabV2 from './v2/IndexFundsTabV2';
import { useIndexFundsV2Access } from './useIndexFundsV2Access';

/**
 * Picks between the classic Index Funds admin table and the v2 redesign, behind a dev toggle
 * (localStorage `vega.dev.indexFundsV2` / `?indexFundsV2=1`). Both live side by side; the classic
 * tab is untouched. See useIndexFundsV2Access.
 */
const IndexFundsTabSwitch: React.FC = () => {
  const [v2, setV2] = useIndexFundsV2Access();

  return (
    <div>
      <div
        style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}
      >
        <Segmented
          size="small"
          value={v2 ? 'v2' : 'classic'}
          onChange={val => setV2(val === 'v2')}
          options={[
            { label: 'Classic', value: 'classic' },
            { label: 'New (v2)', value: 'v2' },
          ]}
        />
      </div>
      {v2 ? <IndexFundsTabV2 /> : <ClassicIndexFundsTab />}
    </div>
  );
};

export default IndexFundsTabSwitch;
